import { render } from "./ItemsFourView.vue?vue&type=template&id=86fea12c&scoped=true"
import script from "./ItemsFourView.vue?vue&type=script&lang=js"
export * from "./ItemsFourView.vue?vue&type=script&lang=js"

import "./ItemsFourView.vue?vue&type=style&index=0&id=86fea12c&scoped=true&lang=css"

import exportComponent from "C:\\AT\\Sites\\agiles_website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86fea12c"]])

export default __exports__